// extracted by mini-css-extract-plugin
export var activityContainer = "_np-0";
export var typingIndicatorContainer = "_np-1";
export var typingIndicatorDot = "_np-2";
export var wave = "_np-3";